<template>
  <div>
    <v-card class="login">
      <v-card-title>
        {{ $t('pages.login.title') }}
      </v-card-title>
      <v-card-text>
        <form @submit.prevent="submit()">
          <v-text-field
            v-if="!platformName"
            v-model="form.platformName"
            name="platformName"
            required
            :label="$t('pages.login.labels.platformName')"
            id="platformName">
          </v-text-field>
          <v-text-field
            v-model="form.email"
            name="email"
            type="email"
            required
            :label="$t('pages.login.labels.email')"
            id="email">
          </v-text-field>
          <v-text-field
            v-model="form.password"
            name="password"
            type="password"
            required
            :label="$t('pages.login.labels.password')"
            id="password">
          </v-text-field>
          <v-btn
            type="submit"
            primary light block ripple
            :loading="loading">
            {{ $t('pages.login.login') }}
          </v-btn>
        </form>

        <v-snackbar error v-model="error" multi-line :timeout="2000">
          {{ error }}
        </v-snackbar>
      </v-card-text>
    </v-card>
    <v-btn block flat light router :href="{ name: 'ForgotPassword' }">{{ $t('pages.login.forgotPassword') }}</v-btn>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    data () {
      return {
        form: {
          email: null,
          password: null,
          platformName: null
        }
      }
    },
    computed: {
      ...mapGetters({
        platformName: 'application/platformName',
        loading: 'skiliko/session/isLoading',
        error: 'skiliko/session/loginError'
      })
    },
    methods: {
      ...mapActions({
        login: 'skiliko/session/login'
      }),
      submit () {
        const data = { ...this.form }
        data.platformName = data.platformName || this.platformName
        this.login(data)
          .then(_ => this.$router.replace({ path: this.$route.query.redirect || '/' }))
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .login {
    width: 350px;
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue